import { generalLink } from "@pkg/sanity-utils/linkQueries";
import groq from "groq";
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

export const blockTilesFields = groq`
...,
tiles[] {
  ...,
  content[] {
    ${portableTextWithReferences}
  },
  link {
    ...,
    link {
      ${generalLink}
    },
  },
  // Make sure that links are not included if containsLink is false
  containsLink == false => {
    "link": null,
  }
}
`;
